Vue.component('content-statistics', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="row">

                <div class="col-md-3 col-sm-6 text-center text-sm-left">

                    <div class="liquid-counter liquid-counter-default liquid-counter-lg text-center text-sm-left">
                        <div class="liquid-counter-element text-black" data-enable-counter="true" data-counter-options='{"targetNumber":"2520","blurEffect":false}'>
                            <span>2520</span>
                        </div><!-- /.liquid-counter-element -->
                        <span class="liquid-counter-text liquid-text-bottom text-primary">PROJECTS DONE</span>
                    </div><!-- /.liquid-counter -->

                </div><!-- /.col-md-3 col-sm-6 -->

                <div class="col-md-3 col-sm-6 text-center text-sm-left">

                    <div class="liquid-counter liquid-counter-default liquid-counter-lg text-center text-sm-left">
                        <div class="liquid-counter-element text-black" data-enable-counter="true" data-counter-options='{"targetNumber":"615","blurEffect":false}'>
                            <span>615</span>
                        </div><!-- /.liquid-counter-element -->
                        <span class="liquid-counter-text liquid-text-bottom text-primary">HAPPY CUSTOMERS</span>
                    </div><!-- /.liquid-counter -->

                </div><!-- /.col-md-3 col-sm-6 -->

                <div class="col-md-3 col-sm-6 text-center text-sm-left">

                    <div class="liquid-counter liquid-counter-default liquid-counter-lg text-center text-sm-left">
                        <div class="liquid-counter-element text-black" data-enable-counter="true" data-counter-options='{"targetNumber":"102","blurEffect":false}'>
                            <span>102</span>
                        </div><!-- /.liquid-counter-element -->
                        <span class="liquid-counter-text liquid-text-bottom text-primary">WINNING AWWARDS</span>
                    </div><!-- /.liquid-counter -->

                </div><!-- /.col-md-3 col-sm-6 -->

                <div class="col-md-3 col-sm-6 text-center text-sm-left">

                    <div class="liquid-counter liquid-counter-default liquid-counter-lg text-center text-sm-left">
                        <div class="liquid-counter-element text-black" data-enable-counter="true" data-counter-options='{"targetNumber":"3,200","blurEffect":false}'>
                            <span>3,200</span>
                        </div><!-- /.liquid-counter-element -->
                        <span class="liquid-counter-text liquid-text-bottom text-primary">EMPLOYEES WORLDWIDE</span>
                    </div><!-- /.liquid-counter -->

                </div><!-- /.col-md-3 col-sm-6 -->

            </div><!-- /.row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        test: function(){

        }
    },
});